const theme = {
  defaultWidth: 1280,
  breakpoints: {
    sm: [
      {
        type: "max-width",
        value: 576,
      },
    ],
    md: [
      {
        type: "max-width",
        value: 768,
      },
    ],
    lg: [
      {
        type: "max-width",
        value: "1240",
      },
    ],
  },
  color: {
    dark: "#111111",
    darkL1: "#222222",
    darkL2: "#555555",
    grey: "#777777",
    greyD1: "#999999",
    greyD2: "#CCCCCC",
    light: "#FFFFFF",
    lightD1: "#F8F8F8",
    lightD2: "#EEEEEE",
    green: "#111111",
    primary: "#111111",
    secondary: "#111111",
    orange: "#FF7A59",
    red: "#FF4D4D",
    purple: "#B39DDB",
    indigo: "#5C6BC0",
  },
  fontFamily: {
    sans:
      "-apple-system, system-ui, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    sansHeavy:
      "Impact, Haettenschweiler, 'Franklin Gothic Bold', Charcoal, 'Helvetica Inserat', 'Bitstream Vera Sans Bold', 'Arial Black', sans-serif",
    sansHelvetica:
      "Frutiger, 'Frutiger Linotype', Univers, Calibri, 'Gill Sans', 'Gill Sans MT', 'Myriad Pro', Myriad, 'DejaVu Sans Condensed', 'Liberation Sans', 'Nimbus Sans L', Tahoma, Geneva, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    sansVerdana:
      "Corbel, 'Lucida Grande', 'Lucida Sans Unicode', 'DejaVu Sans', 'Bitstream Vera Sans', 'Liberation Sans', Verdana, 'Verdana Ref', sans-serif",
    sansTrebuchet:
      "'Segoe UI', Candara, 'Bitstream Vera Sans', 'DejaVu Sans', 'Trebuchet MS', Verdana, 'Verdana Ref', sans-serif",
    mono:
      "Consolas, 'Andale Mono WT', 'Andale Mono', 'Lucida Console', 'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Liberation Mono', 'Nimbus Mono L', Monaco, 'Courier New', Courier, monospace",
    serifTimes:
      "Cambria, 'Hoefler Text', Utopia, 'Liberation Serif', 'Nimbus Roman No9 L Regular', Times, 'Times New Roman', serif",
    serifGeorgia:
      "Constantia, 'Lucida Bright', Lucidabright, 'Lucida Serif', Lucida, 'DejaVu Serif', 'Bitstream Vera Serif', 'Liberation Serif', Georgia, serif",
    serifGaramond:
      "'Palatino Linotype', Palatino, Palladio, 'URW Palladio L', 'Book Antiqua', Baskerville, 'Bookman Old Style', 'Bitstream Charter', 'Nimbus Roman No9 L', Garamond, 'Apple Garamond', 'ITC Garamond Narrow', 'New Century Schoolbook', 'Century Schoolbook', 'Century Schoolbook L', Georgia, serif",
    googleInter: '"Inter", sans-serif',
    googlePoppins: '"Poppins", sans-serif',
  },
  font: {
    headline1: "normal 300 80px/1.1 --fontFamily-googlePoppins",
    headline2: "normal 400 52px/1.2 --fontFamily-googlePoppins",
    headline3: "normal 500 32px/1.2 --fontFamily-googlePoppins",
    base: "normal 300 18px/1.6 --fontFamily-googleInter",
    lead: "normal 300 20px/1.6 --fontFamily-googleInter",
    headline1Lg: "normal 300 50px/1.1 --fontFamily-googlePoppins",
    headline2Lg: "normal 400 38px/1.2 --fontFamily-googlePoppins",
    headline3Lg: "normal 500 22px/1.2 --fontFamily-googlePoppins",
  },
  boxShadow: {
    m: "0 4px 14px 0 rgba(0, 0, 0, 0.05)",
    l: "0 10px 30px -5px rgba(0, 0, 0, 0.08)",
    xl: "0 20px 40px -10px rgba(0, 0, 0, 0.1)",
    xxl: "0 30px 60px -15px rgba(0, 0, 0, 0.12)",
    glass: "none",
  },
  background: {
    primaryGradient:
      "linear-gradient(180deg, --color-primary, transparent) no-repeat 0 0",
    secondaryGradient:
      "linear-gradient(180deg, --color-secondary, transparent) no-repeat 0 0",
  },
  transform: {
    rotate90: "rotate(90deg)",
    rotate180: "rotate(180deg)",
    flipX: "scaleX(-1)",
    flipY: "scaleY(-1)",
  },
  transition: {
    opacityOut:
      "opacity --transitionDuration-normal --transitionTimingFunction-easeOut",
    transformOut:
      "transform --transitionDuration-normal --transitionTimingFunction-easeOut",
    transformInOut:
      "transform --transitionDuration-normal --transitionTimingFunction-easeInOut",
  },
  transitionTimingFunction: {
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    easeOut: "cubic-bezier(0, 0, 0.2, 1)",
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
  },
  transitionDuration: {
    fastest: "0.1s",
    fast: "0.2s",
    normal: "0.3s",
  },
  filter: {
    grayscale: "grayscale(100%)",
    invert: "invert(100%)",
    blur: "blur(10px)",
  },
  animation: {},
  keyframes: {
    fadeIn: [
      {
        key: "from",
        props: [
          {
            opacity: 0,
          },
        ],
      },
      {
        key: "to",
        props: [
          {
            opacity: 1,
          },
        ],
      },
    ],
    fadeOut: [
      {
        key: "from",
        props: [
          {
            opacity: 1,
          },
        ],
      },
      {
        key: "to",
        props: [
          {
            opacity: 0,
          },
        ],
      },
    ],
  },
  components: {
    section: {
      maxWidth: {
        default: "1280px",
      },
      minWidth: {
        default: "300px",
      },
      width: {
        default: "90%",
      },
    },
    stack: {
      gap: {
        default: "32px",
        small: "16px",
      },
    },
  },
  fonts: {
    Inter: {
      family: "Inter",
      type: "google-fonts",
      meta: {
        category: "sans-serif",
        variants: [
          "100",
          "200",
          "300",
          "regular",
          "500",
          "600",
          "700",
          "800",
          "900",
        ],
      },
    },
    Poppins: {
      family: "Poppins",
      type: "google-fonts",
      meta: {
        category: "sans-serif",
        variants: [
          "100",
          "100italic",
          "200",
          "200italic",
          "300",
          "300italic",
          "regular",
          "italic",
          "500",
          "500italic",
          "600",
          "600italic",
          "700",
          "700italic",
          "800",
          "800italic",
          "900",
          "900italic",
        ],
      },
    },
  },
  version: 1,
}
export default theme
